// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OtWaF","input":"styles_input__3QCAT"};